let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2DGin")).then(() => parcelRequire('gfJUJ'));